module.exports = __webpack_public_path__ + "gb-eng.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gb-eng.svg
// module id = 904
// module chunks = 0